module.exports = __webpack_public_path__ + "fronted/src/img/delOn.e37a0b10.png";